import type React from "react";

import { faArrowUpRightFromSquare, faFile, faVideo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import styled, { useTheme } from "styled-components";

import { ailmentConfig } from "routes/calendar/helpers/getAilments";
import { type Resource } from "routes/wiki/data/resources";

interface Props {
  resource: Resource;
}

export const ResourceItem: React.FC<Props> = ({ resource }) => {
  const theme = useTheme();

  const getIcon = () => {
    if (resource.categories?.includes("video")) {
      return <FontAwesomeIcon icon={faVideo} color={theme.colors.primary.base} size="xs" />;
    }

    const ailments = resource?.ailments;
    if (ailments && ailments?.length > 0 && ailments?.length <= 2 && ailments[0] in ailmentConfig) {
      return ailmentConfig[ailments[0]].icon;
    }

    return <FontAwesomeIcon icon={faFile} color={theme.colors.primary.base} size="sm" />;
  };

  return (
    <StyledListItem
      secondaryAction={
        <IconButton href={resource.url} target="_blank">
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} color={theme.colors.primary.base} size="xs" />
        </IconButton>
      }
      disablePadding
    >
      <ListItemButton href={resource.url} target="_blank">
        <ListItemAvatar sx={{ minWidth: 46 }}>
          <Avatar sx={{ bgcolor: theme.colors.white, height: 32, width: 32 }}>{getIcon()}</Avatar>
        </ListItemAvatar>

        <ListItemText primary={resource.title} />
      </ListItemButton>
    </StyledListItem>
  );
};

const StyledListItem = styled(ListItem)`
  border: 1px solid ${({ theme }) => theme.colors.redesign.db20};
  border-radius: 8px;
  margin-bottom: 8px;
`;
